import { useLayerRegistry } from '@/map/layers/registry';
import { getLayerColor, rgbToHex } from '@/map/layers/symbology';
import { isColorableGeometry } from '@/map/layers/renderer';

export function LegendPanel() {
  const records = useLayerRegistry((s) => s.records);
  if (records.length === 0) {
    return <div className="p-3 text-xs text-muted-foreground">No layers configured.</div>;
  }
  return (
    <div className="flex flex-col gap-2 p-3">
      {records.map((r) => {
        const geom = r.probe?.service.geometry_type;
        const colorable = isColorableGeometry(geom);
        const color = colorable ? rgbToHex(getLayerColor(r.id, records)) : undefined;
        return (
          <div key={r.id} className="flex items-center gap-2 text-xs">
            <Swatch geometry={geom} color={color} />
            <div className="min-w-0 flex-1 truncate">{r.id}</div>
            <span className="text-[10px] uppercase text-muted-foreground">
              {geom ?? 'pending'}
            </span>
          </div>
        );
      })}
    </div>
  );
}

function Swatch({ geometry, color }: { geometry?: string; color?: string }) {
  if (!color) {
    return <span className="size-4 rounded-sm border border-dashed border-border" />;
  }
  if (geometry === 'polyline') {
    return (
      <span
        className="block h-1.5 w-4 rounded-sm"
        style={{ backgroundColor: color }}
      />
    );
  }
  if (geometry === 'point' || geometry === 'multipoint') {
    return (
      <span
        className="block size-3 rounded-full border border-white/60"
        style={{ backgroundColor: color }}
      />
    );
  }
  return (
    <span
      className="block size-4 rounded-sm border"
      style={{ backgroundColor: color + '38', borderColor: color }}
    />
  );
}
